// @ts-nocheck
import { Icon, HelpCircleIcon } from 'components/shared/Icon/Icon'
import { useTooltip } from 'hooks'
import { TetherPortal } from 'components/shared/TetherPortal/TetherPortal'
import { Arrow } from 'components/shared/Arrow/Arrow'
import React from 'react'
import { Box } from 'components/layout/Box/Box'
import styles from './IconTooltip.module.scss'

export const IconTooltip = ({
  text,
  icon = HelpCircleIcon,
  className = undefined,
  iconClassName = undefined,
  size = undefined,
  placement = 'right-end',
}) => {
  const {
    state: {
      arrowRef,
      arrowStyle,
      floating,
      floatingStyle,
      reference,
      hasArrow,
      isToggled,
    },
    handlers: {
      handleBlur,
      handleFocus,
      handleMouseEnter,
      handleMouseLeave,
      handleTouchEnd,
      handleTouchStart,
    },
  } = useTooltip({ initialPlacement: placement })

  return (
    <>
      <span
        className={className}
        {...{
          ref: reference,
          onBlur: handleBlur,
          onFocus: handleFocus,
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          onTouchStart: handleTouchStart,
          onTouchEnd: handleTouchEnd,
        }}
      >
        {/* the default colour is dropped rather than merged, since both rules
            are a single class and the winner would come down to bundle order */}
        <Icon className={iconClassName || styles.icon} {...{ icon, size }} />
      </span>
      <TetherPortal className={styles.portal} isOpen={isToggled}>
        <Box
          align="left"
          className={styles.message}
          justify="left"
          ref={floating}
          role="status"
          style={floatingStyle}
        >
          {hasArrow && (
            <Arrow
              ref={arrowRef}
              size="small"
              style={arrowStyle}
              theme="bright"
            />
          )}
          <Box
            align="start"
            className={styles.content}
            direction="column"
            role="tooltip"
          >
            <div className={styles.tooltipTitle}>{text}</div>
          </Box>
        </Box>
      </TetherPortal>
    </>
  )
}
